import axios from "axios";
import { IAssetState, IRoomObject } from "escape-rooms-types/types/game";
import { areArraysEqual, insertCustomColorsIntoSvgText } from "./helpers";

export const loadGameSpecificAssets = (scene: Phaser.Scene, objects: IRoomObject[]) => {
  objects.forEach((object: IRoomObject) => {
    // If object is using default colors, don't load new asset. We will just use the default asset.
    if (areArraysEqual(object.colorPalette, object.asset.defaultColorPalette)) {
      return;
    }

    Object.values(object.asset.states).forEach((state: IAssetState) => {
      const sceneUrlSeg = state.textureUrl.toLowerCase();

      axios.get(`/asset-state-textures/${sceneUrlSeg}.svg`).then((res) => {
        loadSvgFromText(scene, `${object.ref}_${state.name}`.toLowerCase(), res.data, object.colorPalette, {
          scale: 1,
        });
      });
    });
  });
};

const loadSvgFromText = (scene: Phaser.Scene, key: string, svgText: string, colors: string[], config?: any) => {
  // TODO: Get the backend to return the svg as a string.
  const newSvg = insertCustomColorsIntoSvgText(svgText, colors);
  const blob = new Blob([newSvg], { type: "image/svg+xml" });
  const svgUrl = URL.createObjectURL(blob);
  return scene.load.svg(key, svgUrl, config);
};

export const createRandomString = (length: number) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const setCursorToPointer = (scene: Phaser.Scene | undefined) => {
  try {
    if (scene?.input) {
      scene.input.setDefaultCursor("pointer");
    } else if (scene?.sys) {
      scene.sys.canvas.style.cursor = "pointer";
    }
  } catch {
    // Object already destroyed, nothing to set
  }
};

export const setCursorToGrabbing = (scene: Phaser.Scene | undefined) => {
  try {
    if (scene?.input) {
      scene.input.setDefaultCursor("grabbing");
    } else if (scene?.sys) {
      scene.sys.canvas.style.cursor = "grabbing";
    }
  } catch {
    // Object already destroyed, nothing to set
  }
};

export const resetCursorToDefault = (scene: Phaser.Scene | undefined) => {
  try {
    if (scene?.input) {
      scene.input.setDefaultCursor("default");
    } else if (scene?.sys) {
      scene.sys.canvas.style.cursor = "default";
    }
  } catch {
    // Object already destroyed, nothing to set
  }
};
